module.exports = __webpack_public_path__ + "img/ícone-seta-esquerda-azul.a6fe9fea.svg";